// Components==============
import { faCheck, faFolder } from '@fortawesome/pro-solid-svg-icons';
import CircleButton from 'components/UI/CircleButton/CircleButton';
import EvidencePreview from 'components/UI/EvidencePreview/EvidencePreview';
import { AnimatePresence } from 'framer-motion';
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import { ProjectDetailsContext } from 'pages/Workspace/ProjectDetails/ProjectDetails';
import React, { useContext, useState } from 'react';
import { generateTrainingUrl } from 'utilities/generateTrainingUrl';
import Tooltip from 'components/UI/Tooltip/Tooltip';
import Button from '../Button/Button';
import UploadModal from '../UploadModal/UploadModal';
import MultipleUsers from './MultipleUsers/MultipleUsers';
import MultipleEmojis from './MultipleEmojis/MultipleEmojis';
import './ProjectEvidenceButton.module.scss';
// =========================

export default function ProjectEvidenceButton({
  process,
  rootModal,
  disableComments,
  limitButtons,
}: {
  process: ProcessProcessEntity;
  rootModal?: boolean;
  disableComments?: boolean;
  limitButtons?: boolean;
}) {
  const translate = useTranslate();

  const userId = useRedux((state) => state.authentication?.user?.id);

  const [isFinished, setIsFinished] = useState(process.finished || false);

  const {
    handleEvidenceUpload,
    userMembership,
    handleDeleteEvidenceAndFeedback,
    project,
    processGroups,
    handleProcessSave,
    loading,
  } = useContext(ProjectDetailsContext);

  const training = useRedux((state) =>
    process?.process_type === 'App\\Training'
      ? state.training?.entities.byId[process.process_id]
      : undefined
  );

  const buttonsCondition =
    // checks if is reflections because projectDetailsContext is undefined there
    !!project;

  const canEditCondition =
    userMembership === 'owner' ||
    userMembership === 'member' ||
    userMembership === 'admin';

  const isRepeat =
    process?.process_id === 2 && process?.process_type === 'App\\Activity';

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const url = training ? generateTrainingUrl(training) : ' ';

  const isLocked = !!project?.locked_for_assessment;

  function handleIsFinished() {
    const newValue = processGroups?.map((group) => {
      if (
        group.activities.find(
          (activity) =>
            activity.processId === process?.id &&
            (activity.process_type === process?.process_type) !== undefined
        )
      )
        return {
          ...group,
          activities: group.activities.map((activity) =>
            activity.processId === process?.id
              ? {
                  ...activity,
                  finished: activity.finished === 0 ? (1 as 1) : (0 as 0),
                }
              : activity
          ),
        };

      return group;
    });

    setIsFinished((prev) => !prev);
    handleProcessSave(newValue);
  }

  if (isRepeat) return <></>;

  if (
    process.process_type === 'App\\Activity' &&
    !process.evidence?.length &&
    !buttonsCondition
  )
    return <></>;

  return (
    <div styleName="wrapper">
      {process?.process_type === 'App\\Training' && (
        <>
          <p styleName="course-description">
            {translate('project.course-description')}
          </p>
          <Button color="grey" to={url}>
            {translate('project.go-to-training')}
          </Button>
        </>
      )}
      {process?.process_type === 'App\\Activity' && (
        <>
          <div styleName="bar" />
          {!!process.evidence?.length && (
            <EvidencePreview
              evidence={process.evidence}
              deleteCondition={
                project?.members.find((m) => m.membership === 'owner')
                  ?.user_id === userId
              }
              handleDelete={
                isLocked ? undefined : handleDeleteEvidenceAndFeedback
              }
              rootModal={rootModal}
              disableComments={disableComments}
            />
          )}
          {buttonsCondition ? (
            <div styleName="circle-buttons">
              {!!(
                (project?.members.length || 0) > 1 &&
                !limitButtons &&
                canEditCondition &&
                !isLocked
              ) && <MultipleUsers process={process} />}
              <MultipleEmojis process={process} />
              {canEditCondition && !isLocked && (
                <Tooltip
                  disabled={!loading}
                  position="top"
                  content={
                    <p>{translate('project.wait-for-upload-loading')}</p>
                  }
                >
                  <CircleButton
                    inactive={loading}
                    icon={faFolder}
                    color="dark-grey"
                    onClick={() => setModalIsOpen(true)}
                  />
                </Tooltip>
              )}
              {!limitButtons && (
                <CircleButton
                  icon={faCheck}
                  color={isFinished ? 'green' : 'dark-grey'}
                  onClick={handleIsFinished}
                  inactive={!canEditCondition || isLocked}
                />
              )}
            </div>
          ) : null}
        </>
      )}

      <AnimatePresence>
        {modalIsOpen && (
          <UploadModal
            setModalIsOpen={setModalIsOpen}
            handleUpload={(file) =>
              handleEvidenceUpload(
                typeof file === 'string'
                  ? { link: file, processId: process.id }
                  : { file, processId: process.id }
              )
            }
          />
        )}
      </AnimatePresence>
    </div>
  );
}
